import { render, staticRenderFns } from "./ManageAssignAdmin.vue?vue&type=template&id=38c0f467&"
import script from "./ManageAssignAdmin.vue?vue&type=script&lang=js&"
export * from "./ManageAssignAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ManageAssignAdmin.vue?vue&type=style&index=0&id=38c0f467&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports